export const GET_OAUTH_SERVICES = 'getOauthServices'
export const SET_OAUTH_SERVICES = 'setOauthServices'
export const OAUTH_CALLBACK = 'oauthCallback'
export const LOGIN = 'login'
export const LOGOUT = 'logout'
export const SET_ACCESS_TOKEN = 'setAccessToken'
export const DESTROY_TOKEN = 'destroyToken'
export const FORGOT_PASSWORD = 'forgotPassword'
export const RESET_PASSWORD_CHECK_TOKEN='resetPasswordCheckToken'
export const RESET_PASSWORD = 'resetPassword'
export const TWO_FACTOR_AUTHENTICATION = 'twoFactorAuthentication'
export const TWO_FACTOR_AUTHENTICATION_CHECK_TOKEN='twoFactorAuthenticationCheckToken'